import type { FaireProductEntity } from "../../entity_types/product";

export const p_dskbf887qw: FaireProductEntity = {
  token: "p_dskbf887qw",
  type: "product",
  name: "Sky Blue Striped Tan Bunny Cardigan",
  brandToken: "b_dg7nau6taf",
  brandName: "Loralin Design",
  imageUrl:
    "https://cdn.faire.com/fastly/d920e927e8e7fb6c042a5c13b65c11e3067bac1a09872fe1d40b5e73547471fb.jpeg",
  galleryImageUrls: [],
  priceDollars: 26,
  description:
    "Handmade cardigan with adorable handmade embellishment.\n100% Cotton.\nHandwash.\n",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:50.111Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
